import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var WSearchBar = /*#__PURE__*/function (_Vue) {
  function WSearchBar() {
    var _this;
    _classCallCheck(this, WSearchBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WSearchBar, [].concat(args));
    _defineProperty(_this, "placeholder", void 0);
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "height", void 0);
    _defineProperty(_this, "disabled", void 0);
    _defineProperty(_this, "currentValue", '');
    return _this;
  }
  _inherits(WSearchBar, _Vue);
  return _createClass(WSearchBar, [{
    key: "mounted",
    value: function mounted() {
      this.currentValue = this.value;
    }
  }, {
    key: "onInputUpdate",
    value: function onInputUpdate() {
      if (!this.disabled) {
        this.$emit("onInputUpdate", this.currentValue);
      }
    }
  }]);
}(Vue);
export { WSearchBar as default };
__decorate([Prop()], WSearchBar.prototype, "placeholder", void 0);
__decorate([Prop()], WSearchBar.prototype, "value", void 0);
__decorate([Prop({
  default: '240px'
})], WSearchBar.prototype, "width", void 0);
__decorate([Prop({
  default: '32px'
})], WSearchBar.prototype, "height", void 0);
__decorate([Prop({
  default: false
})], WSearchBar.prototype, "disabled", void 0);